import { Image } from "antd";
import { ImageProps } from "./type";
function AntImage(props: ImageProps) {
  return <Image {...props}  />;
}

export { AntImage as ImageComponent };
